import * as yup from 'yup'

export const initialForm = {
  status: true,
  code: '',
  nickName: '',
  firstName: '',
  lastName: '',
  countryCode: '+66',
  phoneNumber: '',
  email: '',
  roleId: '',
  areaIds: [{ id: '' }],
}

export const areaSchema = yup.object().shape({
  id: yup.string(),
})

export const schemaForm = yup.object().shape({
  status: yup.boolean(),
  code: yup.string().required('staff:idRequired.label').max(8),
  nickName: yup.string().required('staff:nickNameRequired.label').max(50),
  firstName: yup.string().required('staff:firstNameRequired.label').max(50),
  lastName: yup.string().required('staff:lastNameRequired.label').max(50),
  countryCode: yup.string(),
  phoneNumber: yup.number().max(15),
  email: yup.string().max(50),
  roleId: yup.string().required('staff:positionRequired.label'),
  areaIds: yup.array().of(areaSchema),
})
